import { useMutation } from "@apollo/client";
import { Button } from "framework7-react";
import { useCallback } from "react";

import { getFragmentData } from "@/generated/graphql";
import { CreateNextActivityByActivityNameDocument, EntryFragmentDoc } from "@/generated/graphql/graphql";
import { useBack } from "@/hooks/useBack";
import { useGetEntryInput } from "@/hooks/useGetEntryInput";
import { useNavigate } from "@/hooks/useNavigate";

type ActivityStarterButtonProps = {
  activityName: string;
  onCompleted?: VoidFunction;
};

export function NewActivityStarterButton({ activityName, onCompleted }: ActivityStarterButtonProps) {
  const routerBack = useBack();
  const navigate = useNavigate();

  const [createNextActivity, { loading }] = useMutation(CreateNextActivityByActivityNameDocument);

  const getEntryInput = useGetEntryInput();

  const handleClick = useCallback(async () => {
    const entryInput = await getEntryInput();

    await createNextActivity({
      onCompleted: (data) => {
        if (data.createEntryByActivityName?.entry) {
          const entry = getFragmentData(EntryFragmentDoc, data.createEntryByActivityName.entry);
          routerBack();
          navigate(`/modals/entries/${entry.id}/update-feeling/`);
        }
      },
      variables: {
        entryInput,
        name: activityName,
      },
    }).finally(onCompleted);
  }, [getEntryInput, createNextActivity, activityName, onCompleted, routerBack, navigate]);

  if (activityName) {
    return (
      <Button
        fill
        large
        preloader
        loading={loading}
        onClick={handleClick}
      >
        <strong style={{ fontSize: "1.3em", marginRight: "0.2em" }}>{activityName}</strong>
        を記録する
      </Button>
    );
  }

  return null;
}
